<template>
  <div class="hello">
    <!-- 循环字段 进行字段的样式设置 addFieldSet -->
    <el-form ref="pageForm" style="background-color: white;" label-width="100px" label-suffix=":">
      <template v-for="(blockOne,blockIndex) in basicBlockArr" >
        <template v-if="(!blockOne.filterName || (blockOne.filterType==1 && (','+blockOne.filterValue+',').indexOf(','+value[blockOne.filterName]+',')>=0) || (blockOne.filterType==2 && (','+blockOne.filterValue+',').indexOf(','+value[blockOne.filterName]+',')==-1))">
          <div :key="'block_basic_'+blockIndex">
            <span style="font-weight: bold;font-size: 18px;color:#057df9;">{{blockOne.blockCnName}}:</span>
            <el-button v-if="blockOne.blockType==2" type="primary" icon="el-icon-plus" circle @click="addBlockField(blockOne)"></el-button>
            <el-row v-if="blockOne.blockType!=2" type="flex" style="flex-wrap:wrap;"  >
              <template v-for="(fieldOne,fieldIndex) in blockOne.fieldArr">
                <OneFieldSet :key="'block_field_'+fieldIndex + '_' + (fieldOne.appendIndex?fieldOne.appendIndex:'')" :fieldOne="fieldOne" v-model="value" :parentValue="value" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId" :pageId="pageId" :pageName="pageName" @fieldValueChange="fieldValueChange"></OneFieldSet>
              </template>
            </el-row>
            <template v-else>
              <el-row v-for="(valueOne,valueOneIndex) in value[blockOne.blockEnName]" :key="'block_arr_'+valueOneIndex" type="flex" style="flex-wrap:wrap;"  >
                <template v-for="(fieldOne,fieldIndex) in blockOne.fieldArr">
                  <OneFieldSet :key="'block_field_'+fieldIndex + '_' + (fieldOne.appendIndex?fieldOne.appendIndex:'')" :fieldOne="fieldOne" v-model="value[blockOne.blockEnName][valueOneIndex]" :parentValue="value" :ImageList="ImageList" :tableId="tableId" :relationTableId="relationTableId" :pageId="pageId"  :pageName="pageName" @fieldValueChange="fieldValueChange"></OneFieldSet>
                </template>
                <el-button :key="'block_delete_field_'+valueOneIndex" type="primary" icon="el-icon-delete-solid" circle style="height:40px;" @click="toDeleteFieldOne(blockOne,valueOneIndex)"></el-button>
              </el-row>
            </template>
          </div>
        </template>
      </template>
      <template v-for="(cssBlockOne,cssBlockIndex) in cssBlockArr" >
        <el-row :key="'row_'+cssBlockIndex"  type="flex" style="flex-wrap:wrap;" v-show="(!cssBlockOne.filterName || (cssBlockOne.filterType==1 && (','+cssBlockOne.filterValue+',').indexOf(','+value[cssBlockOne.filterName]+',')>=0) || (cssBlockOne.filterType==2 && (','+cssBlockOne.filterValue+',').indexOf(','+value[cssBlockOne.filterName]+',')==-1))">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <template v-for="(buttonOne,buttonIndex) in cssBlockOne.buttonArr">
              <el-button :key="'cssButton_'+buttonIndex" type="primary" :title="buttonOne.enName"  @click="openCssBlockDialog(cssBlockIndex,buttonIndex)" v-show="(!buttonOne.filterName || (buttonOne.filterType==1 && (','+buttonOne.filterValue+',').indexOf(','+value[buttonOne.filterName]+',')>=0) || (buttonOne.filterType==2 && (','+buttonOne.filterValue+',').indexOf(','+value[buttonOne.filterName]+',')==-1))">{{buttonOne.cnName}}</el-button>
            </template>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <el-dialog v-if="cssDialogFlag"
              title="设置"
              :visible.sync="cssDialogFlag"
              width=98%
              top="1vh"
              center
              append-to-body>
      <CommonStyleSet v-if="cssBlockArr[cssBlockIndex].buttonArr[cssButtonIndex].type==1" v-model="value[cssBlockArr[cssBlockIndex].buttonArr[cssButtonIndex].enName]" :ImageList="ImageList" ></CommonStyleSet>  
      <ChartShowSet v-if="cssBlockArr[cssBlockIndex].buttonArr[cssButtonIndex].type==2" v-model="value[cssBlockArr[cssBlockIndex].buttonArr[cssButtonIndex].enName]" :ImageList="ImageList" ></ChartShowSet>
    </el-dialog>
  </div>
</template>

<script>
import CommonStyleSet from '@/components/page/pageSet/CommonStyleSet.vue';
import OneFieldSet from '@/components/page/pageSet/OneFieldSet.vue';
import ValuePlug from '@/components/page/pageUtil/ValuePlug.vue';
import TjPlug from '@/components/page/pageUtil/TjPlug.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'PageBasicSet',
  props: {
    value: {
      type:Object,
      default(){
        return {}
      }
    },
    ImageList:{
      type:Array
    },
    tableId:{
      type:Number
    },
    relationTableId:{
      type:Number
    },
    pageId:{
      type:Number
    },
    pageName:{
      type:String,
      default:""
    },
    basicBlockArr:{
      type:Array,
      default:[]
    },
    cssBlockArr:{
      type:Array,
      default:[]
    },
    type:{
      type:Number
    },
    isChild:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
      cssBlockIndex:-1,
      cssButtonIndex:-1,
      cssDialogFlag:false,
    };
  },
  created() {
    var that = this;
    console.log("PageBasicSet==================",that.value);
    //ListFieldBasicSet
    if(this.value) {
      if(this.type == 30) {
        if(this.value.valuePlugId > 0 && !this.value.valuePlugIdJson) {
          this.value.valuePlugIdJson = {
            nameStr:this.value.lmfCvName,
            resultStr:this.value.lmfCv,
            valuePlugId:this.value.valuePlugId
          }
        }
        if(this.value.fieldTjSet && this.value.fieldTjSet.length > 0) {
          this.value.fieldTjSet.forEach(tjColorSetOne =>{
            if(tjColorSetOne.tjPlugId > 0 && !tjColorSetOne.tjIdJson) {
              tjColorSetOne.tjIdJson = {
                nameStr:tjColorSetOne.lmfCvName,
                resultStr:tjColorSetOne.lmfCv,
                tjPlugId:tjColorSetOne.tjPlugId
              }
            }
          })
        }
      } else if(this.type == 4) {
        if(this.value.setBlockingCard){
          this.colBlockNum = this.value.setBlockingCard.length
          this.colProportion = true
        }
      } else if(this.type == 29) {
        //ListFilterSet
        //进行行颜色设置的条件插件初始化
        if(this.value.rowColorSet && this.value.rowColorSet.length > 0) {
          this.value.rowColorSet.forEach(tjColorSetOne =>{
            if(!tjColorSetOne.tjIdJson && tjColorSetOne.showTjId > 0) {
              tjColorSetOne.tjIdJson = {
                nameStr:tjColorSetOne.lmfCvName,
                resultStr:tjColorSetOne.lmfCv,
                tjPlugId:tjColorSetOne.showTjId
              }
            }
          })
        }
        //进行默认排序的值插件初始化
        if(this.value.orderArr && this.value.orderArr.length > 0) {
          this.value.orderArr.forEach(orderSetOne =>{
            console.log("orderSetOne.lmfCv=========",orderSetOne,JSON.stringify(orderSetOne));
            if(!orderSetOne.valuePlugIdJson && orderSetOne.valuePlugId > 0) {
              orderSetOne.valuePlugIdJson = {
                nameStr:orderSetOne.lmfCvName,
                resultStr:orderSetOne.lmfCv,
                valuePlugId:orderSetOne.valuePlugId
              }
            } else if(!orderSetOne.valuePlugIdJson || !orderSetOne.valuePlugIdJson.resultStr) {
              orderSetOne.valuePlugIdJson = {
                nameStr:orderSetOne.fieldName,
                resultStr:'',
                valuePlugId:0
              }
            }
          })
        }
        //进行列表默认过滤条件插件的初始化
        if(this.value.defaultFilter && this.value.defaultFilter.length > 0) {
          this.value.defaultFilter.forEach((defaultFilterSetOne,index) =>{
            var lmfCvName = this.value.defaultFilterName[index];
            var tjPlugId = this.value.defaultFilter[index];
            if(!this.value.defaultFilterArr){
              this.value.defaultFilterArr = [];
            }
            if(this.value.defaultFilterArr.length < (index+1)) {
              this.value.defaultFilterArr.push({
                nameStr:lmfCvName,
                resultStr:"",
                tjPlugId:tjPlugId,
                tjIdJson:{
                  nameStr:lmfCvName,
                  resultStr:'',
                  tjPlugId:tjPlugId
                }
              })
            }
          })
        } else {
          this.value.defaultFilterArr = [];
        }
        //进行子选项卡的选中对象的 初始化 glPageObjTable
        if(this.value.childTabs && this.value.childTabs.length > 0) {
          this.value.childTabs.forEach((childTabOne,index) =>{
            if(childTabOne.glPageObj > 0) {
              childTabOne.glPageObjTable = {
                tableId : childTabOne.glPageObj,
                tableCnName : childTabOne.glPageObjName
              }
            }
            //子选项卡中的关联条件插件
            if(childTabOne.childPageTjList && childTabOne.childPageTjList.length > 0){
              childTabOne.childPageTjList.forEach((childPageTjOne,index) =>{
                if(childPageTjOne.childPageTjId > 0) {
                  childPageTjOne.tjIdJson = {
                    nameStr:childPageTjOne.childPageLmfPlug,
                    resultStr:childPageTjOne.childPageTjPlugId,
                    tjPlugId:childPageTjOne.childPageTjId
                  }
                }
              })
            }
            //子选项卡中的启用条件
            if(childTabOne.tabTjSet && childTabOne.tabTjSet.length > 0){
              childTabOne.tabTjSet.forEach((childPageTjOne,index) =>{
                if(!childPageTjOne.tjIdJson && childPageTjOne.tabQyTjId > 0) {
                  childPageTjOne.tjIdJson = {
                    nameStr:childPageTjOne.tabQyTj,
                    resultStr:childPageTjOne.tabQyTjVal,
                    tjPlugId:childPageTjOne.tabQyTjId
                  }
                }
              })
            }
            //子选项卡中的禁用条件
            if(childTabOne.tabJyTjSet && childTabOne.tabJyTjSet.length > 0){
              childTabOne.tabJyTjSet.forEach((childPageTjOne,index) =>{
                if(!childPageTjOne.tjIdJson && childPageTjOne.tabJyTjId > 0) {
                  childPageTjOne.tjIdJson = {
                    nameStr:childPageTjOne.tabJyTj,
                    resultStr:childPageTjOne.tabJyTjVal,
                    tjPlugId:childPageTjOne.tabJyTj
                  }
                }
              })
            }
          })
        }
        //进行左侧树的解析
        if(this.value.blockArr && this.value.blockArr.length > 3) {
          if(this.value.blockArr[2] > 0){
            if(!this.value.areaPageCombo) {
              this.$set(this.value,"areaPageCombo",{});
            }
            this.value.areaPageCombo.pageId = this.value.blockArr[2];
            this.value.areaPageCombo.value = this.value.blockArr[2];
          }
        }
        //左侧树过滤条件的默认组合
        if(this.value.defaultTreeFilter && this.value.defaultTreeFilter.length > 0) {
          this.value.leftTreePlugJson = {
            nameStr:this.value.lmfCvName,
            resultStr:this.value.lmfCv,
            tjPlugId:this.value.defaultTreeFilter[0]
          }
        }
      } else if(this.type == 33) {
        //SearchFieldBasicSet
        if(this.value.valuePlugId > 0) {
          this.value.valuePlugIdJson = {
            nameStr:this.value.lmfCvName,
            resultStr:this.value.lmfCv,
            valuePlugId:this.value.valuePlugId,
            fieldRole:0,
            tableId:this.value.tcTableId
          }
          if(this.value.tcPageId > 0) {
            this.value.fieldRole = 0;
          }
        }
      } else if(that.type == 31 || that.type == 32) {
        that.basicBlockArr[0].fieldArr[0].dicList.forEach(ele=>{
          ele.ifHide = 0;
          if(ele.filterType && ele.filterType != that.type) {
            ele.ifHide = 1;
          }
        });
        //ButtonBasicSet
        this.value.nowTable = {tableId:this.tableId,showFilterType:"0!20"};
        if(this.value.buttonType == 13 || this.value.buttonType == 3) {
          this.value.nowTable.showFilterType = "20";
        }
        //进行选中外键字段的初始化
        if(!this.value.relationFieldObj || this.value.relationField >= 0) {
          this.$set(this.value,"relationFieldObj",{
            fieldId:this.value.relationField,
            relationTableId:this.value.openTableId
          });
        }
        //子选项卡中的启用条件
        if(this.value.buttonTjSet && this.value.buttonTjSet.length > 0){
          this.value.buttonTjSet.forEach((childPageTjOne,index) =>{
            if(!childPageTjOne.tjIdJson && childPageTjOne.butQyTjId > 0) {
              childPageTjOne.tjIdJson = {
                nameStr:childPageTjOne.butQyTj,
                resultStr:childPageTjOne.butQyTjVal,
                tjPlugId:childPageTjOne.butQyTjId
              }
            }
          })
        }
        //子选项卡中的禁用条件
        if(this.value.buttonJyTjSet && this.value.buttonJyTjSet.length > 0){
          this.value.buttonJyTjSet.forEach((childPageTjOne,index) =>{
            if(!childPageTjOne.tjIdJson && childPageTjOne.butJyTjId > 0) {
              childPageTjOne.tjIdJson = {
                nameStr:childPageTjOne.butJyTj,
                resultStr:childPageTjOne.butJyTjVal,
                tjPlugId:childPageTjOne.butJyTjId
              }
            }
          })
        }
        if(this.value.startTurnPage){
          this.value.startTurnPage = this.value.startTurnPage*1;
        }
      } else if(that.type == 15) {
        //pageFieldBasicBlock
        that.basicBlockArr[0].fieldArr[0].dicList[0].ifHide = 0;
        if(that.isChild == 1 && that.relationTableId > 0) {
          that.basicBlockArr[0].fieldArr[0].dicList[1].ifHide = 0;
          that.basicBlockArr[0].fieldArr[0].dicList[2].ifHide = 0;
        } else {
          that.basicBlockArr[0].fieldArr[0].dicList[1].ifHide = 1;
          that.basicBlockArr[0].fieldArr[0].dicList[2].ifHide = 1;
        }

        if(this.value.fieldId >= 0) {
          this.$set(this.value,"fieldObj",{
            fieldId:this.value.fieldId,
            fieldCnName:this.value.fieldCnName,
            fieldRole:this.value.fieldRole,
            relationTableId:this.value.relationTableId,
            dicParId:this.value.dicParId
          });
          if(this.value.tableId == this.tableId) {
            this.$set(this.value,"fieldOrPlug",1);
          } else {
            this.$set(this.value,"fieldOrPlug",2);
          }
        }
        if(this.value.valuePlugId > 0) {
          this.value.valuePlugIdJson = {
            nameStr:this.value.lmfCvName,
            resultStr:this.value.lmfCv,
            valuePlugId:this.value.valuePlugId
          }
          this.value.fieldOrPlug = 
          this.$set(this.value,"fieldOrPlug",3);
        }
        if(this.value.fieldRole == 20 || this.value.fieldRole == 22) {
           this.$set(this.value,"dialogFieldObj",this.value.fieldObj);
        }
        if(this.value.dialogField >= 0) {
          this.$set(this.value,"dialogFieldObj",{
            fieldId:this.value.dialogField,
            relationTableId:this.value.dialogTableId
          });
        }
        if(this.value.tjPlugVal > 0) {
          this.$set(this.value,"tjIdJson",{
            nameStr:this.value.tjPluglmfCvName,
            resultStr:this.value.tjPluglmfCv,
            tjPlugId:this.value.tjPlugVal
          });
        } else if(!this.value.tjIdJson) {
          this.$set(this.value,"tjIdJson",{
            nameStr:"",
            resultStr:"",
            tjPlugId:0
          });
        }
        // if(this.value.defaultValue > 0) {
        //   this.$set(this.value,"defaultValIdJson",{
        //     nameStr:this.value.defaultLmfCvName,
        //     resultStr:this.value.defaultLmfCv,
        //     valuePlugId:this.value.defaultValue
        //   });
        // } else 
        if(!this.value.defaultValIdJson) {
          this.$set(this.value,"defaultValIdJson",{
            nameStr:'',
            resultStr:'',
            valuePlugId:0
          });
        }
      } else if(that.type == 36) {
        //查看页面选项卡
        if(that.value.glWjId>0){
          this.$set(this.value,"fieldObj",{
            fieldId:this.value.glWjId,
            relationTableId:this.value.relationObjId,
          });
        }
        if(that.value.relationObjId) {
          this.$set(this.value,"relationObjIdTable",{
            tableId:that.value.relationObjId,
            tableCnName:that.value.relationObj
          });
        }
        if(this.value.otherPageTjId > 0) {
          this.$set(this.value,"otherPageTjIdJson",{
            nameStr:this.value.otherPageLmfPlug,
            resultStr:this.value.otherPageLmfPlugId,
            tjPlugId:this.value.otherPageTjId
          });
        }
        if(this.value.qyTjList && this.value.qyTjList.length > 0){
          this.value.qyTjList.forEach((childPageTjOne,index) =>{
            if(!childPageTjOne.tjIdJson && childPageTjOne.gl_qyTjId > 0) {
              childPageTjOne.tjIdJson = {
                nameStr:childPageTjOne.gl_qyTjLmfName,
                resultStr:childPageTjOne.gl_qyTjLmfId,
                tjPlugId:childPageTjOne.gl_qyTjId
              }
            }
          })
        }
        if(this.value.jyTjList && this.value.jyTjList.length > 0){
          this.value.jyTjList.forEach((childPageTjOne,index) =>{
            if(!childPageTjOne.tjIdJson && childPageTjOne.gl_jyTjId > 0) {
              childPageTjOne.tjIdJson = {
                nameStr:childPageTjOne.gl_jyTjLmfName,
                resultStr:childPageTjOne.gl_jyTjLmfId,
                tjPlugId:childPageTjOne.gl_jyTjId
              }
            }
          })
        }
      }
    }
  },
  mounted() {
  },
  beforeDestroy(){
    
  },
  watch:{
    value:function(){
      console.log("watch-------------------value================",this.value);
    }
  },
  computed:{
  },
  components: {
    CommonStyleSet,
    OneFieldSet,
    ValuePlug,
    TjPlug
  },
  methods: {
    fieldValueChange:function(fieldOne){
      var that = this;
      console.log("fieldValueChange==============2222===================",that.type,fieldOne,this.value);
      //ListFieldBasicSet
      if(that.type == 30) {
        if(fieldOne.enName=="valuePlugIdJson") {
          if(!this.value.lgName && this.value.valuePlugIdJson && this.value.valuePlugIdJson.nameStr) {
            this.value.lgName = this.value.valuePlugIdJson.nameStr.split(":")[0];
          }
          this.value.lmfCvName = this.value.valuePlugIdJson.nameStr;
          this.value.lmfCv = this.value.valuePlugIdJson.resultStr;
          this.value.valuePlugId = this.value.valuePlugIdJson.valuePlugId;
        }
      } else if(that.type == 33) {
        if(fieldOne.enName=="valuePlugIdJson") {
          this.$set(this.value,"dicParId",this.value.valuePlugIdJson.dicParId);
          this.$set(this.value,"fieldType",this.value.valuePlugIdJson.resultType);
          this.$set(this.value,"fieldRole",this.value.valuePlugIdJson.fieldRole);
          this.$set(this.value.valuePlugIdJson,"tableId",this.value.valuePlugIdJson.lastResultJson.lastCheckFieldOne.tableId);
          this.$set(this.value,"tcTableId",this.value.valuePlugIdJson.lastResultJson.lastCheckFieldOne.tableId);
          if(!this.value.lgName && this.value.valuePlugIdJson && this.value.valuePlugIdJson.nameStr) {
            this.value.lgName = this.value.valuePlugIdJson.nameStr.split(":")[0];
          }
        }
      } else if(that.type == 31 || that.type == 32) {
        //ButtonBasicSet
        if(fieldOne.enName=="relationFieldObj") {
          this.basicBlockArr[0].fieldArr.forEach(tmpField =>{
            if(tmpField.enName == "startTurnPage") {
              tmpField.appendIndex = tmpField.appendIndex>0?(tmpField.appendIndex+1):1;
            } 
          })
        } else if(fieldOne.enName=="buttonType") {

          this.basicBlockArr[0].fieldArr.forEach(tmpField =>{
            if(tmpField.enName == "startTurnPage") {
              tmpField.appendIndex = tmpField.appendIndex>0?(tmpField.appendIndex+1):1;
              this.value.startTurnPage = null;
            } 
          })
        }
        if(fieldOne.enName=="startTurnPageDic") {
          that.$set(that.value,"startTurnPageUrl",that.value.startTurnPageDic);
        }
      } else if(that.type == 15) {
        if(fieldOne.enName=="fieldObj") {
          that.$set(that.value,"fieldId",that.value.fieldObj.fieldId);
          that.$set(that.value,"fieldCnName",that.value.fieldObj.fieldCnName);
          that.$set(that.value,"fieldRole",that.value.fieldObj.fieldRole);
          that.$set(that.value,"relationTableId",that.value.fieldObj.relationTableId);
          that.$set(that.value,"tableId",that.value.fieldObj.tableId);
          that.$set(that.value,"dicParId",that.value.fieldObj.dicParId);
          if(that.value.fieldRole == 20 || that.value.fieldRole == 22) {
            that.$set(that.value,"dialogFieldObj",that.value.fieldObj);
          }
        } else if(fieldOne.enName=="dialogFieldObj") {
          that.$set(that.value,"pageDialog",null);
        }
        if(fieldOne.enName=="valuePlugIdJson") {
          if(!this.value.fieldCnName && this.value.valuePlugIdJson && this.value.valuePlugIdJson.nameStr) {
            this.value.fieldCnName = this.value.valuePlugIdJson.nameStr.split(":")[0];
          }
          if(this.value.valuePlugIdJson) {
            that.$set(that.value,"lmfCvName",that.value.valuePlugIdJson.nameStr);
            that.$set(that.value,"lmfCv",that.value.valuePlugIdJson.resultStr);
            that.$set(that.value,"valuePlugId",that.value.valuePlugIdJson.valuePlugId);
          }
        } 
        if(fieldOne.enName=="defaultValIdJson" && this.value.defaultValIdJson) {
          that.$set(that.value,"defaultLmfCvName",that.value.defaultValIdJson.nameStr);
          that.$set(that.value,"defaultLmfCv",that.value.defaultValIdJson.resultStr);
          that.$set(that.value,"defaultValue",that.value.defaultValIdJson.valuePlugId);
        }
      } else if(that.type == 36) {
        if(fieldOne.enName=="fieldObj") {
          that.$set(that.value,"glWjId",that.value.fieldObj.fieldId);
          //如果是添加修改查看页面则对象自动选中
          if(that.value.type != 1) {
            this.$set(this.value,"relationObjIdTable",{
              tableId:that.value.fieldObj.relationTableId,
              tableName:that.value.fieldObj.relationTableName
            });
            this.$set(this.value,"relationObjId",that.value.fieldObj.relationTableId);
            this.$set(this.value,"relationObj",that.value.fieldObj.relationTableName);
          }
          // that.$set(that.value,"glWjId",that.value.fieldObj.relationTableId);
        }
        if(fieldOne.enName=="relationObjIdTable") {
          this.$set(this.value,"relationObjId",that.value.relationObjIdTable.tableId);
          this.$set(this.value,"relationObj",that.value.relationObjIdTable.tableCnName);
        }
        if(fieldOne.enName=="otherPageTjIdJson" && that.value.otherPageTjIdJson) {
          that.$set(that.value,"otherPageTjId",that.value.otherPageTjIdJson.tjPlugId);
          that.$set(that.value,"otherPageLmfPlug",that.value.otherPageTjIdJson.nameStr);
          that.$set(that.value,"otherPageLmfPlugId",that.value.otherPageTjIdJson.resultStr);
        }
      }
      that.$emit("fieldValueChange");
      that.$forceUpdate();
    },
    openCssBlockDialog(cssBlockIndex,cssButtonIndex){
      var that = this;
      that.cssBlockArr.forEach(cssBlockOne => {
        cssBlockOne.buttonArr.forEach(cssButtonOne => {
          if(!that.value[cssButtonOne.enName]) {
            that.$set(that.value,cssButtonOne.enName,{});
          }
        });
      });
      that.cssBlockIndex = cssBlockIndex;
      that.cssButtonIndex = cssButtonIndex;
      that.cssDialogFlag = true;
    },
    addBlockField:function(blockOne){
      pageUtils.addBlockField(this,blockOne);
    },
    toDeleteFieldOne:function(blockOne,valueOneIndex){
      this.value[blockOne.blockEnName].splice(valueOneIndex,1);
      if(blockOne.blockEnName == 'defaultFilterArr') {
        if(this.value['defaultFilterName']) {
          this.value['defaultFilterName'].splice(valueOneIndex,1);
        }
        if(this.value['defaultFilter']) {
          this.value['defaultFilter'].splice(valueOneIndex,1);
        }
      }
      this.$forceUpdate();
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-col{min-height: 41px;padding: 3px}
</style>
